/**
 * @generated SignedSource<<d3dc98558ec7ee468b8e0676e5626039>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TaskDeleteInput = {
  id: string;
};
export type TaskId_taskDeleteMutation$variables = {
  input: TaskDeleteInput;
};
export type TaskId_taskDeleteMutation$data = {
  readonly taskDelete: {
    readonly id: string;
  };
};
export type TaskId_taskDeleteMutation = {
  response: TaskId_taskDeleteMutation$data;
  variables: TaskId_taskDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskId_taskDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "taskDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskId_taskDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "taskDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a41acdab1fa1903ea6a28337316a2ad8",
    "id": null,
    "metadata": {},
    "name": "TaskId_taskDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation TaskId_taskDeleteMutation(\n  $input: TaskDeleteInput!\n) {\n  taskDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c884ffd6a64897f80df9fee5c5369db";

export default node;
